<section *ngIf="selectedGridFormType === gridFormTypeAcuity">        
    <smt-grid-input-variable-shiftblocks [costCenter]="costCenter" [readOnly]="readOnly"></smt-grid-input-variable-shiftblocks> 
    <div class="staffing-grid-buttons">
        <smt-staffing-grid-buttons [costCenter]="costCenter" [readOnly]="readOnly"></smt-staffing-grid-buttons>
    </div>   
    <h3 *ngIf="isFixedSelected()">Fixed Job Titles</h3>
    <h3 *ngIf="isVariableSelected()">Variable Job Titles to Patient Ratio</h3>
    <label>{{ getGridLabel() }}</label>
    <smt-acuity-grid *ngIf="isAllWeekVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-acuity-grid>    
    <smt-acuity-grid *ngIf="isSaturdayVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-acuity-grid>    
    <smt-acuity-grid *ngIf="isSundayVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-acuity-grid>     
    <smt-acuity-grid *ngIf="isWeekdayVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-acuity-grid>      
    <smt-acuity-grid *ngIf="isWeekendVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-acuity-grid>           
    <smt-fixed-jobs-shift-grid *ngIf="isAllWeekFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>    
    <smt-fixed-jobs-shift-grid *ngIf="isSaturdayFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>    
    <smt-fixed-jobs-shift-grid *ngIf="isSundayFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>
    <smt-fixed-jobs-shift-grid *ngIf="isWeekdayFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>
    <smt-fixed-jobs-shift-grid *ngIf="isWeekendFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>    
</section>
<section *ngIf="selectedGridFormType === gridFormTypeInpatient">
    <smt-shiftblock-input [startHour]="selectedShiftBlockHour" (startHourChanged)="onChangeStartHour($event)"></smt-shiftblock-input>  
    <div class="staffing-grid-buttons">
        <smt-staffing-grid-buttons [costCenter]="costCenter" ></smt-staffing-grid-buttons>
    </div>        
    <smt-variable-jobs-shift-grid *ngIf="isWeekdayVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-variable-jobs-shift-grid>
    <smt-variable-jobs-shift-grid *ngIf="isWeekendVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-variable-jobs-shift-grid>    
    <smt-fixed-jobs-shift-grid *ngIf="isWeekdayFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>
    <smt-fixed-jobs-shift-grid *ngIf="isWeekendFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>
</section>
<section *ngIf="selectedGridFormType === gridFormTypeTotalUos">      
    <smt-grid-input-variable-shiftblocks [costCenter]="costCenter" [readOnly]="readOnly"></smt-grid-input-variable-shiftblocks> 
    <div class="staffing-grid-buttons">
        <smt-staffing-grid-buttons [costCenter]="costCenter" [readOnly]="readOnly"></smt-staffing-grid-buttons>
    </div>  
    <h3 *ngIf="isFixedSelected()">Fixed Job Titles</h3>
    <h3 *ngIf="isVariableSelected()">Variable Job Title Hours to UOS Ratio</h3> 
    <h3 *ngIf="isAddOnsSelected()">Add Ons</h3> 
    <label>{{ getGridLabel() }}</label>
    <smt-add-ons-grid *ngIf="isAllWeekAddOnsSelected()"
        [costCenter]="costCenter" 
        [(isStaffingGridSaved)]='isStaffingGridSaved'
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-add-ons-grid>
    <smt-add-ons-grid *ngIf="isSaturdayAddOnsSelected()"
        [costCenter]="costCenter" 
        [(isStaffingGridSaved)]='isStaffingGridSaved'
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-add-ons-grid>
    <smt-add-ons-grid *ngIf="isSundayAddOnsSelected()"
        [costCenter]="costCenter" 
        [(isStaffingGridSaved)]='isStaffingGridSaved'
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-add-ons-grid> 
    <smt-add-ons-grid *ngIf="isWeekdayAddOnsSelected()"
        [costCenter]="costCenter" 
        [(isStaffingGridSaved)]='isStaffingGridSaved'
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-add-ons-grid>   
    <smt-add-ons-grid *ngIf="isWeekendAddOnsSelected()"
        [costCenter]="costCenter" 
        [(isStaffingGridSaved)]='isStaffingGridSaved'
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-add-ons-grid> 
    <smt-variable-job-uos-grid *ngIf="isAllWeekVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-variable-job-uos-grid>
    <smt-variable-job-uos-grid *ngIf="isSaturdayVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-variable-job-uos-grid>
    <smt-variable-job-uos-grid *ngIf="isSundayVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-variable-job-uos-grid>    
    <smt-variable-job-uos-grid *ngIf="isWeekdayVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-variable-job-uos-grid>
    <smt-variable-job-uos-grid *ngIf="isWeekendVariableSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-variable-job-uos-grid>
    <smt-fixed-jobs-shift-grid *ngIf="isAllWeekFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>
    <smt-fixed-jobs-shift-grid *ngIf="isSaturdayFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>
    <smt-fixed-jobs-shift-grid *ngIf="isSundayFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>
    <smt-fixed-jobs-shift-grid *ngIf="isWeekdayFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>
    <smt-fixed-jobs-shift-grid *ngIf="isWeekendFixedSelected()"
        [costCenter]="costCenter" 
        [startHour]="selectedShiftBlockHour"
        [type]="selectedGridType"
        [schedules]="schedules"
        [readOnly]="readOnly">
    </smt-fixed-jobs-shift-grid>    
</section>
